export default class BlackAndWhite {
	constructor() {
		this.saturationValue = -1;
		this.luminance = {
			minValue: 0,
			maxValue: 2,
		};

		this.opacity = {
			minValue: 0,
			maxValue: 100,
		};
	}

	addBlock(blockNum = lutify.blocks.length, data) {
		UI.createAdjustmentBlockTemplate("black-and-white", blockNum);
		let element = UI.getAdjustmentBlock(blockNum);

		$(element)
			.find(".control-color-selector > span")
			.on("click", (e, animate) => this.controlColorSelection(e.currentTarget, animate));
		$(element)
			.find(".btn-reset-block")
			.off("click.reset")
			.on("click", e => {
				e.stopPropagation();
				blocks.resetBlock($(element), null, 1);
			});

		$(element)
			.find(".expand_options")
			.trigger("click", [false]);
		$(element)
			.find(`.control-color-selector > span[data-color="reds"]`)
			.trigger("click", [false]);

		$(element)
			.find(".range_slider:not(.opacity_slider)")
			.on("input", e => {
				blocks.checkSwitchHandler($(element));
				this.sliderHandler($(e.currentTarget));
			});

		$(element)
			.find(".range_value:not(.opacity-input)")
			.on("change", e => {
				blocks.checkSwitchHandler($(element));
				this.sliderHandler($(e.currentTarget));
			});

		$(element).find(".opacity_slider").on("input", () => this.opacitySliderHandler($(element)));
		$(element).find(".opacity-input").on("change", () => this.opacityInputHandler($(element)));

		UI.initKnob(element, {
			size: 30,
		});

		blocks.add({
			name: "blackAndWhite",
			passes: this.addPasses(),
			blockNum,
			blendingMode: 0,
			blendingModeName: "Normal",
			opacity: 100,
			values: {
				luminance: {
					Reds: 1,
					Yellows: 1,
					Greens: 1,
					Cyans: 1,
					Blues: 1,
					Magentas: 1,
				},
			},
		});

		if (data?.initial) $(element).find('.switch input').trigger('click');
	}

	addPasses() {
		let hueSaturationPass1 = gpu.createHueSaturationShaderPass();

		let hueSaturationPass2 = gpu.createHueSaturationShaderPass();
		hueSaturationPass2.uniforms["satReds"].value = this.saturationValue;
		hueSaturationPass2.uniforms["satYellows"].value = this.saturationValue;
		hueSaturationPass2.uniforms["satGreens"].value = this.saturationValue;
		hueSaturationPass2.uniforms["satCyans"].value = this.saturationValue;
		hueSaturationPass2.uniforms["satBlues"].value = this.saturationValue;
		hueSaturationPass2.uniforms["satMagentas"].value = this.saturationValue;

		gpu.addPassToComposer(hueSaturationPass1, "toMiddle");
		gpu.addPassToComposer(hueSaturationPass2, "toMiddle");

		gpu.render();
		return [hueSaturationPass1, hueSaturationPass2];
	}

	controlColorSelection(selectedColorControl, animate = true) {
		let $controlsContainer = $(selectedColorControl).closest(".block_options");
		$controlsContainer.find(".control-color-selector > span").removeClass("selected");
		$(selectedColorControl).addClass("selected");
		if (animate) {
			$controlsContainer.find(".block-sub-controls-container").fadeOut(2);
			$controlsContainer.find(`.block-sub-controls-container[data-color="${selectedColorControl.dataset.color}"]`).fadeIn();
		} else {
			$controlsContainer.find(`.block-sub-controls-container[data-color="${selectedColorControl.dataset.color}"]`).show();
		}
	}

	sliderHandler($element) {
		let value = parseFloat($element.val());
		let color = $element.data("range");

		if ($element.hasClass("range_value")) {
			if (value > this.luminance.maxValue) {
				value = this.luminance.maxValue;
				$element.val(value);
			}
			if (value < this.luminance.minValue) {
				value = this.luminance.minValue;
				$element.val(value);
			}
		}

		if ($element.hasClass("range_slider"))
			$element
				.closest(".block-sliders-container")
				.find(".range_value")
				.val(value);
		else
			$element
				.closest(".block-sliders-container")
				.find(".range_slider")
				.val(value);

		// lutify.getActiveBlock().color = value;
		lutify.getActiveBlock().values.luminance[color] = value;

		this.updateLuminance(value - 1, color);
	}

	updateLuminance(value, color) {
		lutify.getActiveBlock().passes[0].enabled = true;
		lutify.getActiveBlock().passes[0].uniforms["lum" + color].value = value;
		gpu.render();
	}

	opacitySliderHandler($element) {
		let opacityValue = $element.find(".opacity_slider").val();
		let calcOpacityValue = opacityValue * 0.01;

		$element.find(".opacity-input").val(opacityValue);

		lutify.getActiveBlock().opacity = opacityValue;
		lutify.getActiveBlock().passes.forEach(pass => {
			pass.uniforms.opacity.value = calcOpacityValue;
		})

		gpu.render();
	}

	opacityInputHandler($element) {
		let opacityValue = $element.find(".opacity-input").val();
		let opacitySlider = $element.find(".opacity_slider");

		if (opacityValue > this.opacity.maxValue) opacityValue = this.opacity.maxValue;
		if (opacityValue < this.opacity.minValue) opacityValue = this.opacity.minValue;

		opacitySlider.val(opacityValue);
		opacitySlider.trigger("input");
	}

	applyChanges($block, values, blockData) {
		Object.keys(values.luminance).forEach(color => {
			let slider = $block.find(`.block-sliders-container[data-sub-control="luminance"] > .range_slider[data-range="${color}"]`);
			slider.val(values.luminance[color]);
			slider.trigger("input");
		});

		if ('opacity' in blockData) {
			$block.find(".opacity-input").val(parseInt(blockData.opacity));
			$block.find(".opacity-input").trigger("change");
		}
	}
}
